import { useState } from "react";

const SetIssueDate = ({ isOpen, onCancel, onConfirm,selectedIssueDate,setSelectedIssueDate }) => {
   
  

  return (
    <div className={`w-full bg-pink-100 transition-all duration-1000 overflow-hidden ${
        isOpen ? "max-h-[1000px] opacity-100 scale-100" : "max-h-0 opacity-0 scale-100"
      }`}>
      <div className="bg-white p-6 rounded-lg shadow-xl  text-center">
        <h2 className=" font-semibold text-gray-800">Select Date:</h2>
       
        <input
            type="date"
            value={selectedIssueDate}
            className={`w-full max-w-[200px] w-[99%] mt-2 p-1 border-b-2 border-gray-200 focus:border-red-700 focus:outline-none transition-colors duration-300`}
            onChange={(e)=>setSelectedIssueDate(e.target.value)}
          />
        <div className="flex justify-center mt-4 space-x-3">
          <button
            onClick={onCancel}
            className="text-xs px-4 py-2 bg-gray-300 text-gray-800 rounded-md hover:bg-gray-400 transition"
          >
            CANCEL
          </button>
        <button
  onClick={onConfirm}
  disabled={!selectedIssueDate}
  className={`text-xs px-4 py-2 rounded-md transition 
    ${!selectedIssueDate ? "bg-gray-400 cursor-not-allowed" : "bg-blue-600 hover:bg-blue-700 text-white"}`}
>
  SET ALL ISSUE DATES
</button>
        </div>
      </div>
    </div>
  );
};
export default SetIssueDate;


